import React, { useEffect, useState } from "react";
import axios from "axios";
import { 
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, 
  Paper, Button, TextField, Select, MenuItem, 
} from "@mui/material";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; 

const AccessRevoked = () => {
  const [users, setUsers] = useState([]);
  const [distinctRoles, setDistinctRoles] = useState([]);
  const [newUser, setNewUser] = useState({ emailId: "", role: "" });
  const [addingUser, setAddingUser] = useState(false); 

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/revokedUsers`)
      .then((response) => {
        setUsers(response.data.users);
        setDistinctRoles(response.data.distinctRoles);
      })
      .catch((error) => console.error("Error fetching users:", error));
  }, []);

  const handleAddUser = async () => {
    if (!newUser.emailId || !newUser.role) {
      alert("Please enter email and role.");
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/api/users`, newUser);
      setUsers([response.data.user, ...users]); 
      setNewUser({ emailId: "", role: "" }); 
      setAddingUser(false); 
    } catch (error) {
      console.error("Error adding user:", error);
    }
  };

  const toggleAccess = async (userId, isActive) => {
    try {
      await axios.put(`${API_BASE_URL}/api/users/${userId}`, { active: !isActive });
      setUsers(users.map((user) => (user._id === userId ? { ...user, active: !isActive } : user)));
    } catch (error) {
      console.error("Error updating user access:", error);
    }
  };
  

  return (
<>    

 <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Email</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>Active</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>

            {addingUser && (
              <TableRow>
                <TableCell>
                  <TextField 
                    fullWidth 
                    placeholder="Enter Email"
                    value={newUser.emailId} 
                    onChange={(e) => setNewUser({ ...newUser, emailId: e.target.value })}
                  />
                </TableCell>
                <TableCell>
                  <Select
                    fullWidth
                    value={newUser.role}
                    onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>Select Role</MenuItem>
                    {distinctRoles.map((role) => (
                      <MenuItem key={role} value={role}>{role}</MenuItem>
                    ))}
                  </Select>
                </TableCell>
                <TableCell>Active</TableCell>
                <TableCell>
                  <Button variant="contained" onClick={handleAddUser}>Save</Button>
                  <Button variant="contained" onClick={() => setAddingUser(false)} style={{ marginLeft: "10px" }}>Cancel</Button>
                </TableCell>
              </TableRow>
            )}

            {users.map((user) => (
              <TableRow key={user._id}>
                <TableCell>{user.emailId}</TableCell>
                <TableCell>{user.role}</TableCell>
                <TableCell>{user.active ? "Yes" : "No"}</TableCell>
                <TableCell>
                  <Button 
                     backgroundColor="black"
                    variant="contained" 
                    onClick={() => toggleAccess(user._id, user.active)}
                  >
                    {user.active ? "Revoke Access" : "Restore Access"}
                  </Button>
                </TableCell>
              </TableRow>
            ))}

          </TableBody>
        </Table>
      </TableContainer>
   </>
  );
};

export default AccessRevoked;
